import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { RangePipe } from '@smw/utils-front';

import { CardSkeletonLoaderComponent } from '../card-skeleton-loader/card-skeleton-loader.component';

@Component({
  selector: 'smw-card-grid',
  templateUrl: 'card-grid.component.html',
  styleUrls: ['card-grid.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CardSkeletonLoaderComponent, RangePipe],
})
export class CardGridComponent {
  isLoading = input.required<boolean>();
  isEmpty = input.required<boolean>();
  placeholderCount = input<number>(3);
}
